<script>
  import Tailwindcss from "./components/Tailwindcss.svelte";
  import { pagingStore } from "./stores/paging.js";
  import Page from "./components/page.svelte";
  import Paging from "./components/paging.svelte";
  import Lara from "./components/lara.svelte";

  import Cover from "./pages/cover.svelte";
  import Intro from "./pages/intro.svelte";
  import Intro2 from "./pages/intro2.svelte";
  import Day1 from "./pages/day1.svelte";
  import Day2 from "./pages/day2.svelte";
  import Day3 from "./pages/day3.svelte";
  import Day4 from "./pages/day4.svelte";
  import Day5 from "./pages/day5.svelte";
  import Day6 from "./pages/day6.svelte";
  import Day7 from "./pages/day7.svelte";
  import Day8 from "./pages/day8.svelte";
  import Day9 from "./pages/day9.svelte";
  import Day10 from "./pages/day10.svelte";
  import Day11 from "./pages/day11.svelte";
  import Day12 from "./pages/day12.svelte";
  import Validarien from "./pages/validarien.svelte";
  import End from "./pages/end.svelte";

  import { stylesBackground, stylesScale } from "./stores/styles.js";

  export let pages;
  pages.forEach(page => {
    pagingStore.addPage(page);
  });
  pagingStore.init();
</script>

<style>
  :global(body) {
    overflow: hidden;
    font-family: calluna, serif;
    font-weight: 400;
    font-style: normal;
  }

  main {
    padding: 0;
    margin: 0;
    height: 100vh;

    background: var(--background);
    transform: scale(var(--scale));
    transition: background 1s ease-in-out,
      transform 2s ease-in-out;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>

<main style="--background:{$stylesBackground}; --scale:{$stylesScale}">
  <Page id="intro">
    <Intro />
  </Page>
  <Page id="intro2">
    <Intro2 />
  </Page>
  <Page id="day1">
    <Day1 />
  </Page>
  <Page id="day2">
    <Day2 />
  </Page>
  <Page id="day3">
    <Day3 />
  </Page>
  <Page id="day4">
    <Day4 />
  </Page>
  <Page id="day5">
    <Day5 />
  </Page>
  <Page id="day6">
    <Day6 />
  </Page>
  <Page id="day7">
    <Day7 />
  </Page>
  <Page id="day8">
    <Day8 />
  </Page>
  <Page id="day9">
    <Day9 />
  </Page>
  <Page id="day10">
    <Day10 />
  </Page>
  <Page id="day11">
    <Day11 />
  </Page>
  <Page id="day12">
    <Day12 />
  </Page>
  <Page id="validarien">
    <Validarien />
  </Page>
  <Page id="end">
    <End />
  </Page>
    <Page id="cover">
    <Cover />
  </Page>
  <Paging />
  <Lara />
</main>
<Tailwindcss />
